import React, { Component } from 'react';

import Header from '../../components/Header/Header';
import Page from '../../components/Page/Page';
import Editor from '../../components/Editor/Editor';
import Modal from '../../components/Modal/Modal';
import Footer from '../../components/Footer/Footer';

import { menuItems, modalItems } from '../../data/menu.js';

import './App.css';

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menuItems,
            menuStatus: 'closed',
            modalContent: modalItems.uitleg,
            modalStatus: 'closed',
            editorStatus: 'closed',
            editorPlayer: null,
            players: [],
            name: '',
            labelAxis: '\n\n\n\n\nlabel assen',
            labelX: 'label x-as',
            labelY: 'label y-as'
        }
    }

  handleClickHamburger= (event) => {
    let status = (this.state.menuStatus === "closed") ? "open" : "closed";
    this.setState({ menuStatus: status});
  }

  handleClickMenu = (event) => {
    event.preventDefault();
    this.setState({
      modalStatus: 'open',
      modalContent: modalItems[event.target.id],
      menuStatus: 'closed'
    });
  }

  handleClickModal = () => {
    this.setState({
      modalStatus: 'closed',
    });
  }

  handleChangeTitle = (event) => {
    this.setState({ name: event.target.value });
  }

  handleChangelabelAxis = (event) => {
    this.setState({ labelAxis: event.target.value });
  }

  handleChangelabelX = (event) => {
    this.setState({ labelX: event.target.value });
  }

  handleChangelabelY = (event) => {
    this.setState({ labelY: event.target.value });
  }

  handleClickPlus = () => {
    const players = this.state.players;
    const newIndex = players.length > 0 ? players[players.length-1].id+1 : 1;
    const newPlayer = {
      id: newIndex,
      name: '',
      xPosition: 50,
      yPosition: 50,
      color: 0,
      size: 5
    }
    players.push(newPlayer)
    this.setState({
      players,
      editorStatus: 'open',
      editorPlayer: newIndex
    });
  }

  handleClickPlayer = (player) => {
    this.setState({
      editorStatus: 'open',
      editorPlayer: player.id
    });
  }

  handleCloseEditor = () => {
    this.setState({
      editorStatus: 'closed',
      editorPlayer: null
    });
  }

  handleChangeName = (id, name) => {
    const players = this.state.players
      .map((player) => {
        if (player.id === id) player.name = name;
        return player;
      });
    this.setState({
      players,
      editorPlayer: id
    });
  }

  handleChangeColor = (id, color) => {
    const players = this.state.players
      .map((player) => {
        if (player.id === id) player.color = color;
        return player;
      });
    this.setState({ players });
  }

  handleChangeSize = (id, size) => {
    const players = this.state.players
      .map((player) => {
        if (player.id === id) player.size = size;
        return player;
      });
    this.setState({ players });
  }

  handleDeletePlayer = (id) => {
    const players = this.state.players
      .filter((player) => (player.id !== id));
    this.setState({
      players,
      editorStatus: 'closed'
    });
  }

  handleUpdatePlayers = (player) => {
    const players = this.state.players
      .map((item) => {
        return (item.id === player.id) ? player : item;
      });
    this.setState({ players });
  }

  handleClickSave = (event) => {
      event.preventDefault();
      const contentFile = JSON.stringify({
        name: this.state.name,
        players: this.state.players,
        labelAxis: this.state.labelAxis,
        labelX: this.state.labelX,
        labelY: this.state.labelY
      });
      const downloadSupported = ("download" in document.createElement("a"));
      var filename = this.state.name.replace(/ /g, "-");
      var downloadlink = document.createElement('a');
      filename = filename + ".json";
      downloadlink.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(contentFile));
      downloadlink.setAttribute('download', filename);
      downloadlink.style.display = 'none';
      document.body.appendChild(downloadlink);
      if (downloadSupported) downloadlink.click();
      else console.log("Klik rechts op deze link en kies voor 'opslaan als'");
      document.body.removeChild(downloadlink);
      this.setState({menuStatus:'closed'});
  }

  handleClickOpen= (event) => {
      const reader = new FileReader();
      let file = event.target.files[0];
      reader.readAsText(file, "UTF-8");
      const component = this;
      reader.onload = function() {
          let content = JSON.parse(reader.result);
          component.setState(content);
          component.setState({menuStatus:'closed'});
      };
  }

  handleClickPrint= (event) => {
    event.preventDefault();
    window.print();
  }

  render() {

    const appClass = (this.state.modalStatus === 'open') ? 'app modalOpen' : 'app';
    const editorPlayer = this.state.players.filter(player => player.id === this.state.editorPlayer)[0];

    return (
      <div className={appClass}>
        <Header
          name={this.state.name}
          items={this.state.menuItems}
          status={this.state.menuStatus}
          handleClickHamburger={this.handleClickHamburger}
          handleChangeTitle={this.handleChangeTitle}
          handleClickMenu={this.handleClickMenu}
          handleClickSave={this.handleClickSave}
          handleClickOpen={this.handleClickOpen}
          handleClickPrint={this.handleClickPrint}
        />
        <Page
          labelAxis={this.state.labelAxis}
          labelX={this.state.labelX}
          labelY={this.state.labelY}
          players={this.state.players}
          editorPlayer={editorPlayer}
          handleChangelabelAxis={this.handleChangelabelAxis}
          handleChangelabelX={this.handleChangelabelX}
          handleChangelabelY={this.handleChangelabelY}
          handleUpdatePlayers={this.handleUpdatePlayers}
          handleClickPlus={this.handleClickPlus}
          handleClickPlayer={this.handleClickPlayer}
          handleCloseEditor={this.handleCloseEditor}
          width={this.state.width}
          height={this.state.height}
        />
        <Editor
          status={this.state.editorStatus}
          player={editorPlayer}
          handleCloseEditor={this.handleCloseEditor}
          handleChangeName={this.handleChangeName}
          handleChangeSize={this.handleChangeSize}
          handleChangeColor={this.handleChangeColor}
          handleDeletePlayer={this.handleDeletePlayer}
        />
        <Modal
          content={this.state.modalContent}
          status={this.state.modalStatus}
          handleClickModal={this.handleClickModal}
        />
        <Footer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.js